import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import GlobalStyle from './styles/GlobalStyle';
import Layout from './components/layout';
import ScrollToTop from './components/common/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/Blog/BlogPost';
import Calculator from './pages/Calculator';
import Dashboard from './pages/Dashboard';
import AccessibilityWidget from './components/AccessibilityWidget';
import WhatsAppButton from './components/WhatsAppButton';
import CookieConsent from './components/CookieConsent';
import Accessibility from './pages/Accessibility';
import NewMortgage from './pages/Services/NewMortgage';
import LoanConsolidation from './pages/Services/LoanConsolidation';
import RefinanceMortgage from './pages/Services/RefinanceMortgage';
import RejectedMortgage from './pages/Services/RejectedMortgage';
import ReverseMortgage from './pages/Services/ReverseMortgage';
import TransferMortgage from './pages/Services/TransferMortgage';
import FamilyFinance from './pages/Services/FamilyFinance';
import CreditAdvice from './pages/Services/CreditAdvice';
import Privacy from './pages/Privacy';

const App = () => {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <GlobalStyle />
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <AccessibilityWidget />
            <WhatsAppButton />
            <CookieConsent />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/new" element={<NewMortgage />} />
              <Route path="/services/refinance" element={<RefinanceMortgage />} />
              <Route path="/services/rejected" element={<RejectedMortgage />} />
              <Route path="/services/consolidation" element={<LoanConsolidation />} />
              <Route path="/services/reverse" element={<ReverseMortgage />} />
              <Route path="/services/transfer" element={<TransferMortgage />} />
              <Route path="/services/family" element={<FamilyFinance />} />
              <Route path="/services/credit" element={<CreditAdvice />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/calculator" element={<Calculator />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default App;
